import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';

export const Container = styled.div`
    display: grid;
    grid-auto-flow: row;
    row-gap: ${({ logInError }) => (logInError ? '0px' : '8px')};
    grid-auto-rows: max-content;
`;

export const Label = styled.label`
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
`;

export const Optional = styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
    color: #63666A;
`;

export const Input = styled.input`
    padding: 12px 16px;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    border: 1px solid #63666A;
    border-radius: 1px;
    min-width: 0;

    &:focus {
        outline-color: #FFDFD0;
        outline-width: 3px;
        outline-offset: 2px;
        border-color: #D9D9D6;
    }

    &:hover:not(:focus) {
        border-color: ${colors.BLACK};
    }

    &::placeholder {
        color: #AAAAAA;
    }
`;

export const Error = styled.p`
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: #D44333;
    margin-bottom: -25px;
`;
